import APITemplate from './APITemplate'

const headers = {
  accept: 'application/json',
  'content-type': 'application/json'
}

export default {
  ...APITemplate('/car'),
  getItemsWith (expand) {
    const controller = new AbortController()
    return {
      promise: fetch('/car?expand=' + expand.toString(), {
        method: 'GET',
        credentials: 'include',
        redirect: 'error',
        signal: controller.signal,
        headers
      })
        .then(response => {
          if (response.status !== 200) {
            throw new Error('Ошибка при загрузке.')
          }
          return new Promise((resolve, reject) => {
            response.json().then(items => {
              resolve({
                items
              })
            })
          })
        }),
      abort () {
        controller.abort()
      }
    }
  },
  getTrack (id, sTime, eTime) {
    const request = `car/track?id=${id}&s_datetime=${sTime}&e_datetime=${eTime}`
    const controller = new AbortController()
    return {
      promise: fetch(request, {
        method: 'GET',
        credentials: 'include',
        redirect: 'error',
        signal: controller.signal,
        headers
      })
        .then(response => {
          if (response.status !== 200) {
            throw new Error('Ошибка при загрузке.')
          }
          return new Promise((resolve, reject) => {
            response.json().then(track => {
              resolve({
                track
              })
            })
          })
        }),
      abort () {
        controller.abort()
      }
    }
  }
}
